import { t } from '@moovly/i18n';
import * as React from 'react';
import Page from '../../../components/Page';
import PurchaseSubsriptionButtonContainer from '../containers/PurchaseSubsriptionButtonContainer';
import SubscriptionsTableContainer from '../containers/SubscriptionsContainer';
import { LocalStorageService } from '@moovly/clients';
import _ from 'lodash';

const SubscriptionsPage = () => {
  // FIXME useSettingUpdate not working for backoffice settings
  const canPurchaseSubscriptions = _.get(
    JSON.parse(LocalStorageService.getItem('moovly.groupSettings') || '{}'),
    'backoffice.purchase_subscriptions',
    false
  );
  return (
      <Page
          header="subscriptions"
          description={t('subscription.description')}
          title={t('menu.subscriptions')}
          actions={canPurchaseSubscriptions && <PurchaseSubsriptionButtonContainer/>}
      >
        <SubscriptionsTableContainer/>
      </Page>
  );
}

export default SubscriptionsPage;
